export const RULES = [
  { n: '01', t: 'The Pause is sacred.',
    p: 'Any dad may call a pause for a diaper, a snack, or a small human screaming downstairs. No questions. No timer.',
    stamp: 'Article I · Bylaws' },
  { n: '02', t: 'No queues past midnight.',
    p: 'Bedtime is non-negotiable for dads, too. Saturday is a stretch goal. Sunday is for laundry.',
    stamp: 'Article II · Sleep' },
  { n: '03', t: 'Mute before the wife hears.',
    p: 'We love this team. We love our partners more. Hot mic = bench game. No appeals.',
    stamp: 'Article III · Audio' },
  { n: '04', t: 'If you DC, we assume diaper.',
    p: 'Disconnect with no explanation is a free pass. Twice in one night is a team meeting.',
    stamp: 'Article IV · Trust' },
  { n: '05', t: 'Children > rotations.',
    p: 'If your kid wakes up, you wake up. The minimap can wait. The toddler cannot.',
    stamp: 'Article V · Priority' },
  { n: '06', t: 'We rank up together.',
    p: "If one dad can't queue, we don't ladder without him. We watch replays and complain about sleep.",
    stamp: 'Article VI · Loyalty' },
  { n: '07', t: 'Pause is a sacred state.',
    p: "Yes, we said this twice. It's that important. Do not unpause without verbal confirmation from the dad who paused.",
    stamp: 'Article VII · Sacred' }
];
